import React from "react";

import RightPanel from "components/Monitoring/RightPanel";
import MainGraph from "components/Monitoring/MainGraph";
import BarGraphs from "components/Monitoring/BarGraphs";
import Subgroups from "components/Monitoring/Subgroups";
import AlertCard from "components/Monitoring/AlertCard";
import UserFeedback from "containers/Monitoring/UserFeedback";
import RetrainFrontiers from "components/Monitoring/RetrainFrontiers";
import DataEvaluation from "components/Monitoring/DataEvaluation";

import ComplianceGraphContainer from "containers/Monitoring/ComplianceGraph";
import { SUBGROUP_DATA, OVERALL_DATA } from "components/Monitoring/RetrainFrontiers";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { isEnabled } from "utils/featureFlags";

import { ALERT_TYPES, GRAPH_MODES, MONITOR_VIEW_MODES } from "containers/Monitoring/reducer";
import { getIsMonitoringDemo } from "containers/Monitoring/reducer";

import styles from "./style.module.css";
import { ButtonGroup, Button } from "aible";

export default class Monitoring extends React.Component {
  state = {
    selectedRetrain: undefined,
    ignored: {}
  };

  handleClose() {
    return this.setState({ selectedRetrain: undefined });
  }

  handleRetrain(label, count) {
    return this.setState({
      selectedRetrain: {
        label,
        count
      }
    });
  }

  handleUpdateIgnored(value, isIgnored) {
    return this.setState({
      ...this.state.ignored,
      [value]: isIgnored ? true : undefined
    });
  }

  render() {
    const {
      id,
      segmentId,
      warnings,
      adjustAssumptions,
      monitoringData,
      latestData,
      latestScenario,
      scenarioIndex,
      isContinuous,
      monitorViewMode,
      updateMonitorViewMode,
      userFeedback,
      deleteUserFeedback,
      selectedDataset,
      compliancePlot,
      timePeriod,
      setupLabels,
      isLoading,
      targetValue,
      targetValueOptions,
      updateTargetValue,
      graphMode,
      graphModeOptions,
      updateGraphMode
    } = this.props;

    if (isLoading) {
      return (
        <div className={styles.monitoringWrapper}>
          <div className={styles.monitoringBody + " " + styles.monitoringError}>
            <div className={styles.monitoringErrorTitle}>{"Loading Monitoring Data..."}</div>
            <div className={styles.monitoringErrorBody}>
              <LoadingIndicator />
            </div>
          </div>
        </div>
      );
    }

    if (
      !(
        monitoringData &&
        monitoringData[segmentId] &&
        monitoringData[segmentId].data &&
        monitoringData[segmentId].data.length
      )
    ) {
      return (
        <div className={styles.monitoringWrapper}>
          <div className={styles.monitoringBody + " " + styles.monitoringError}>
            <div className={styles.monitoringErrorTitle}>{"No Monitoring Data Found"}</div>
            <div className={styles.monitoringErrorBody}>{"There is no monitoring data for this subgroup."}</div>
            <div className={styles.monitoringErrorBody}>
              {
                "Monitoring data is updated every 24 hours, so please check back later if you have recently made changes."
              }
            </div>
          </div>
        </div>
      );
    }

    const label = latestData && latestData[segmentId] && latestData[segmentId].label;
    const segmentWarnings = warnings && warnings[segmentId];
    const latestSegmentScenarios = latestScenario && latestScenario[segmentId];
    const segmentScenarios = monitoringData && monitoringData[segmentId] && monitoringData[segmentId].scenarios;

    const hasCompliancePlot = isEnabled("user-compliance");
    const showMenu = hasCompliancePlot;
    return (
      <div className={styles.monitoringWrapper}>
        <div className={styles.monitoringBody}>
          {showMenu && (
            <ButtonGroup style={{ margin: "10px 10px 20px" }}>
              <Button
                onClick={() => updateMonitorViewMode(MONITOR_VIEW_MODES.IMPACT)}
                active={monitorViewMode === MONITOR_VIEW_MODES.IMPACT}
              >
                {setupLabels[targetValue + "Label"]}
              </Button>
              {/* <Button
              onClick={() => updateMonitorViewMode(MONITOR_VIEW_MODES.DATA_EVALUATION)}
              active={monitorViewMode === MONITOR_VIEW_MODES.DATA_EVALUATION}
            >
              {"Data Evaluation"}
            </Button> */}
              <Button
                onClick={() => updateMonitorViewMode(MONITOR_VIEW_MODES.USER_BEHAVIOR)}
                active={monitorViewMode === MONITOR_VIEW_MODES.USER_BEHAVIOR}
              >
                {"User Analytics"}
              </Button>
            </ButtonGroup>
          )}
          {getIsMonitoringDemo() ? (
            <RetrainFrontiers
              isOpen={this.state.selectedRetrain !== undefined}
              data={this.state.selectedRetrain}
              handleClose={() => this.handleClose()}
              updateIgnored={(value, isIgnored) => this.handleUpdateIgnored(value, isIgnored)}
              ignored={this.state.ignored}
              selectedDataset={selectedDataset}
            />
          ) : (
            ""
          )}
          {monitorViewMode === MONITOR_VIEW_MODES.IMPACT ? (
            <React.Fragment>
              <MainGraph
                latestScenarios={latestSegmentScenarios}
                scenarios={segmentScenarios}
                label={label}
                scenarioIndex={scenarioIndex}
                isContinuous={isContinuous}
                setupLabels={setupLabels}
                targetValue={targetValue}
                targetValueOptions={targetValueOptions}
                updateTargetValue={updateTargetValue}
                graphMode={graphMode}
                graphModeOptions={graphModeOptions}
                updateGraphMode={updateGraphMode}
              />
              <BarGraphs
                adjustAssumptions={() => adjustAssumptions()}
                data={latestData && latestData[segmentId]}
                isContinuous={isContinuous}
                timePeriod={timePeriod}
                setupLabels={setupLabels}
              />
              <Subgroups
                data={monitoringData}
                isContinuous={isContinuous}
                handleRetrain={getIsMonitoringDemo() ? (label, count) => this.handleRetrain(label, count) : undefined}
                setupLabels={setupLabels}
                graphMode={graphMode}
                targetValue={targetValue}
                targetValueOptions={targetValueOptions}
              />
            </React.Fragment>
          ) : monitorViewMode === MONITOR_VIEW_MODES.USER_BEHAVIOR ? (
            <React.Fragment>
              <ComplianceGraphContainer id={id} />
              <UserFeedback id={id} compliancePlot={compliancePlot} />
            </React.Fragment>
          ) : monitorViewMode === MONITOR_VIEW_MODES.DATA_EVALUATION ? (
            <React.Fragment>
              <DataEvaluation
                monitoringData={monitoringData && monitoringData[segmentId] && monitoringData[segmentId].data}
              />
            </React.Fragment>
          ) : monitorViewMode === MONITOR_VIEW_MODES.USER_COMPLIANCE ? (
            <React.Fragment>
              <ComplianceGraphContainer id={id} />
            </React.Fragment>
          ) : (
            ""
          )}
        </div>
        <RightPanel isOpen={Boolean(segmentWarnings && segmentWarnings.length)} title={"Performance Alerts"}>
          {segmentWarnings &&
            segmentWarnings.map((warning, i) => (
              <AlertCard
                key={"alert-" + i}
                data={warning}
                adjustAssumptions={adjustAssumptions}
                timePeriod={timePeriod}
                setupLabels={setupLabels}
              />
            ))}
        </RightPanel>
      </div>
    );
  }
}
